import { render, staticRenderFns } from "./zeroActivity.vue?vue&type=template&id=2921f6ce&scoped=true&"
import script from "./zeroActivity.vue?vue&type=script&lang=js&"
export * from "./zeroActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921f6ce",
  null
  
)

export default component.exports